<template>
  <el-card
    class="detail"
    v-loading="!isLoadForm"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <SiruiSearch
      ref="payableStatementListSearch"
      :query="query"
      :columns="searchFormColumns"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @changeSettlementCenterHandler="changeSettlementCenterHandler"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></SiruiSearch>

    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="tableLoading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="true"
        :footerMethod="footerMethod"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          type="seq"
          width="50"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'settlementBusinessType'">{{
              dictListMap?.businessCategoryPayable?.find(
                (item) => item.value == row['settlementBusinessType']
              )?.label
            }}</template>
            <template v-else-if="item.field === 'settlementStatus'">{{
              settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'paymentStatus'">{{
              payPaymentStatus?.find((item) => item.value == row['paymentStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'settlementType'">
              {{ row.settlementType == '1' ? '预结算' : '终结算' }}
            </template>
            <template v-else-if="item.field === 'printFlag'">
              {{ row.printFlag == 0 ? '未打印' : '已打印' }}
            </template>
            <template v-else-if="item.field === 'pushJinDieFlag'">
              {{ row.pushJinDieFlag == 0 ? '失败' : row.pushJinDieFlag == 1 ? '成功' : '' }}
            </template>
            <!-- 物贸板块根据code展示单位 -->
            <template v-else-if="item.field === 'payunit'">
              {{
                row.payunitCode && userInfo.businessGroup == '物贸'
                  ? dictListMap.basic_unit?.find((item) => item.value == row['payunitCode'])?.label
                  : row.payunit
              }}
            </template>
            <!-- 物贸板块使用千分位显示金额 -->
            <template
              v-else-if="
                [
                  'originalTotalAmount',
                  'domesticTotalAmount',
                  'paidAmount',
                  'unpaidAmount',
                ].includes(item.field) && userInfo.businessGroup == '物贸'
              "
            >
              {{ $utils.commafy($utils.toNumber(row[item.field]), { digits: 2 }) }}
            </template>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="row[item.field]"
                @click="goOaLink(row[item.field])"
                >查看</a
              >
            </template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
    <Print ref="easyPrintRef">
      <PrintDemo :content="content" />
    </Print>
    <PrintDialog ref="printDialogRef" @printHandler="printHandler" />
    <AddDialog ref="addDialogRef" @chooseBusinessHandler="chooseBusinessHandler" />
  </el-card>
</template>

<script>
  import { mapState } from 'vuex';
  import { searchColumns, defaultTableColumn } from './index.js';
  // defaultMenuBtnList,
  import { filterEmpty } from '@/common/js/util';
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import Print from '@/components/Print';
  import PrintDemo from '@/components/Print/printDemo';
  import statementListMixin from './index.js';
  import PrintDialog from '../../../components/PrintDialog.vue';
  import AddDialog from './components/AddDialog.vue';
  import { fmoney } from '@/common/js/util';

  export default {
    mixins: [statementListMixin],
    name: 'payableListCK',
    data() {
      return {
        tableLoading: false,
        tableData: [],
        query: {
          pageNum: 1,
          pageSize: 10,
          settlementCompanyNo: '',
          settlementDepartmentNo: '',
          supplierNo: '',
          settlementCenter: '',
          settlementDateStart: '',
          settlementDateEnd: '',
          domesticTotalAmountStart: '',
          domesticTotalAmountEnd: '',
          orderNo: '',
          contractNoLike: '',
          payableSettlementNo: '',
          settlementStatus: '',
          paymentStatus: '',
          salesmanNo: '',
          settlementType: '',
          printFlag: '',
          settlementBusinessType: '',
        },
        companyCode: null,
        storageName: '',
        isLoadForm: true,
        tableTotal: 0,
        multipleSelection: [],
        content: '',
        id: null, //打印id
        publicPath: '',
        publicName: '',
        publicTitle: '应付结算单',
        menuButtonList: [], // 表格功能按钮
        columnList: [],
      };
    },
    methods: {
      // 底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['settlementQuantitySum'].includes(column.property)) {
              return fmoney(
                this.replaceZeroStr(
                  data
                    .reduce((cur, next) => cur + +next.settlementQuantitySum, 0)
                    .toFixed(this.isWuMaoAccount ? 8 : 2)
                ),
                this.isWuMaoAccount ? 8 : 2
              );
            } else if (['originalTotalAmount'].includes(column.property)) {
              return fmoney(
                this.replaceZeroStr(
                  data.reduce((cur, next) => cur + +next.originalTotalAmount, 0).toFixed(2)
                )
              );
            } else if (['domesticTotalAmount'].includes(column.property)) {
              return fmoney(
                this.replaceZeroStr(
                  data.reduce((cur, next) => cur + +next.domesticTotalAmount, 0).toFixed(2)
                )
              );
            }
            return null;
          }),
        ];
      },
      //分页
      changePageHandler(pageNum, pageSize) {
        this.getTableData(pageNum, pageSize);
        // this.getQueryData(pageNum, pageSize);
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          // TODO 后端还没处理好返回数据，前端先这样处理
          // this.menuButtonList = e.length > 0 ? e : defaultMenuBtnList;
          this.menuButtonList = e.length > 0 ? e : [];
          console.log(e, '查看按钮列表');
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn(this)).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn(this);
        });
      },
      //处理查询数据
      getQueryData() {
        const query = Object.assign({}, this.$refs.payableStatementListSearch.query);
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.printFlag = query.printFlag === '0' ? 0 : query.printFlag === '1' ? 1 : '';
        return filterEmpty(query);
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      //修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0].personNo;
        console.log(val, '修改业务员');
      },
      chooseClick(type) {
        console.log(type, '点击按钮操作');
        // this[type]();
        if (type == 'add') {
          this.addNewSettleAccountsHandler();
        } else if (type == 'edit') {
          this.editSettleAccountsHandler();
        } else if (type == 'delete') {
          this.deleteBtnClickHandler();
        } else if (type == 'export') {
          this.exportSettleAccountsHandler();
        } else if (type == 'close') {
          this.closeSettleAccountsHandler();
        } else if (type == 'lock') {
          this.lockSettleAccountsHandler();
        } else if (type == 'print') {
          this.printBtnClickHandler();
        } else if (type == 'pushJindie') {
          this.pushJindieBtnClickHandler();
        } else if (type == 'withdrawApprovalHandler') {
          if (!this.multipleSelection.length) {
            this.$message.error('请选择行操作');
            return;
          }
          if (this.multipleSelection.some((item) => item.settlementStatus != '02')) {
            this.$message.error('只有审批中才可以撤回审批');
            return;
          }
          this.tableLoading = true;
          this.$axios
            .post('/financial/payableSettlement/withdrawOA', {
              businessGroup: this.userInfo.businessGroup,
              ids: this.multipleSelection.map((item) => item.id),
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              const { code, msg } = res.data;
              this.tableLoading = false;
              if (code == 0) {
                this.$message.success('撤回成功');
                this.queryBtnClickHandler();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              this.tableLoading = false;
            });
        } else if (type == 'paySubmit') {
          this.paySubmitBtnClickHandler();
        }
      },
      // 付款申请
      async paySubmitBtnClickHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        if (selectedList.length > 1) {
          this.$message.error('只能选择一行编辑');
          return;
        }
        const selected = selectedList[0];
        if (selected.settlementStatus != '04') {
          this.$message.error('只能选择结算单状态已通过数据');
          return;
        }
        if (selected.payPayableSettlementNo) {
          this.$message.error(
            `该预结算单已被终结算单：${selected.payPayableSettlementNo}关联,不能发起付款申请!`
          );
          return;
        }
        if (selected.originalTotalAmount == '0') {
          this.$message.error('该预结算单原币结算金额(含税)为0,不能发起付款申请!');
          return;
        }
        this.loading.startLoading();
        let postData = {
          id: selected?.id,
          settlementBusinessType: selected.settlementBusinessType,
        };
        // let postData = { id: 41 };
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.PAYBLES_PAYMENTAPPLICATION_API,
          postData
        );
        if (data.code == 0) {
          let path = {
            path: '/payment/applyAddCK',
            name: 'applyAddCK',
            meta: {
              keepAlive: true,
              title: '付款申请单创建',
            },
            query: { isEdit: 'Y', businessType: selected.settlementBusinessType },
            params: data.data,
          };
          this.loading.endLoading();
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.loading.endLoading();
          this.$message('付款申请失败');
        }
      },
      // 导出
      async exportSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (selectedList.length > 0) {
          const postData = [];
          selectedList.map((item) => {
            postData.push(+item.id);
          });
          const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_EXPORT, {
            ids: postData,
          });
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else if (data.code === 5000) {
            this.$message.error(`${data.msg}`);
          } else {
            this.$message.error(`${data.msg}`);
          }
        } else {
          const postData = this.query;
          const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_EXPORT, postData);
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else {
            this.$message.error(`${data.msg}`);
          }
        }
      },
      // 编辑
      editSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        if (selectedList.length > 1) {
          this.$message.error('只能选择一行编辑');
          return;
        }
        const editList = selectedList.filter((item) => {
          return ['02', '04', '06', '07'].includes(item.settlementStatus);
        });
        console.log(editList, '编辑');
        if (editList.length > 0) {
          this.$message.error('选中的包括了不能编辑的数据');
          return;
        }
        console.log(selectedList, 'selectedList');
        // if (!['01'].includes(selectedList[0].settlementBusinessType)) {

        if (!['01', '02', '03', '04', '05'].includes(selectedList[0].settlementBusinessType)) {
          this.$message.error('其他业务板块正在开发中！');
          return;
        } else {
          this.judgeBusinessType(selectedList[0]);
        }

        let path = {
          path: `/receivablesAndPayables/${this.publicPath}`,
          name: `${this.publicName}`,
          meta: {
            keepAlive: true,
            title: `${this.publicTitle}`,
          },
          query: {
            status: 'edit',
            payNo: selectedList[0].payableSettlementNo,
            id: selectedList[0].id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      judgeBusinessType(row) {
        if (['01'].includes(row.settlementBusinessType)) {
          this.publicPath = 'tradePayablesDetail';
          this.publicName = 'tradePayablesDetail';
          this.publicTitle = '贸易应付结算单';
        } else if (['02'].includes(row.settlementBusinessType)) {
          this.publicPath = 'multimodalTransportPayablesDetail';
          this.publicName = 'multimodalTransportPayablesDetail';
          this.publicTitle = '多式联运应付结算单';
        } else if (['04'].includes(row.settlementBusinessType)) {
          this.publicPath = 'leaseContractDetail';
          this.publicName = 'leaseContractDetail';
          this.publicTitle = '三方租赁应付结算单 ';
        } else if (['03'].includes(row.settlementBusinessType)) {
          this.publicPath = 'parkPropertyPayablesDetail';
          this.publicName = 'parkPropertyPayablesDetail';
          this.publicTitle = '园区物业应付结算单';
        } else if (['05'].includes(row.settlementBusinessType)) {
          this.publicPath = 'chengkuangPayablesCreate';
          this.publicName = 'chengkuangPayablesCreate';
          this.publicTitle = '城矿应付结算单';
        }
      },
      //删除
      deleteBtnClickHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const deleteList = selectedList.filter((item) => {
          return ['02', '04', '06', '07'].includes(item.settlementStatus);
        });

        console.log(deleteList, '删除');
        if (deleteList.length > 0) {
          this.$message.error('选中的包括了不能删除的数据');
          return;
        }

        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_DELETE, postData);
            if (data.code === 0) {
              this.$message.success('删除成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //关闭
      async closeSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const closeList = selectedList.filter((item) => {
          return ['02', '03'].includes(item.paymentStatus);
        });

        console.log(closeList, '关闭');
        if (closeList.length > 0) {
          this.$message.error('选中的包括了不能关闭的数据');
          return;
        }
        this.$confirm('确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_CLOSE, postData);
            if (data.code === 0) {
              this.$message.success('关闭成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      async pushJindieBtnClickHandler() {
        const selectedList = this.multipleSelection;
        console.log(selectedList, 'selectedList');
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const receiveList = selectedList.filter((item) => {
          return ['04'].includes(item.settlementStatus);
        });

        const pushJinDieFlagList = selectedList.filter((item) => {
          return [1].includes(item.pushJinDieFlag);
        });
        console.log(receiveList, '关闭');
        if (receiveList.length < 1 && pushJinDieFlagList.length > 0) {
          this.$message.error('只有已通过且未推送成功的数据才能推送到金蝶');
          return;
        }
        this.$confirm('确定要推送到金蝶吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYBLES_PUSHJINDIE_API, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('推送成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },

      //锁定
      async lockSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const lockList = selectedList.filter((item) => {
          return ['01', '02', '03', '05', '06', '07'].includes(item.settlementStatus);
        });

        console.log(lockList, '锁定');
        if (lockList.length > 0) {
          this.$message.error('选中的包括了不能锁定的数据');
          return;
        }
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_LOCK, postData);
            if (data.code === 0) {
              this.$message.success('锁定成功');
              this.queryBtnClickHandler();
            } else if (data.code === 10000) {
              this.$message.error(`${data.msg}`);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //打印
      printBtnClickHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        if (selectedList.length > 1) {
          this.$message.error('只能选择一行打印');
          return;
        }
        let settlementStatusList = selectedList.filter((item) =>
          ['04'].includes(item.settlementStatus)
        );
        console.log(settlementStatusList, 'processStatusList');
        if (settlementStatusList.length == 0) {
          this.$message.error('只有已通过的结算单才能进行打印');
          return;
        }

        this.$refs.printDialogRef.openDialog();
        this.id = selectedList[0].id;
        // this.loading.startLoading();
        // const params = {
        //   id: selectedList[0].id,
        //   downloadOrPrint: 'print',
        // };
        // this.$axios.post(PAYABLES_TRADE.PAYABLELIST_PRINT, params).then((res) => {
        //   if (res.data.code === 0) {
        //     // this.loading.endLoading();
        //     if (res.data.data.pdf) {
        //       // window.location.href = res.data.data.pdf;
        //       window.open(res.data.data.pdf, '_blank');
        //     } else if (res.data.data.excel) {
        //       this.content = res.data.data.excel || '';
        //       setTimeout(() => {
        //         this.$refs.easyPrint.print();
        //       }, 500);
        //     }
        //   } else {
        //     // this.loading.endLoading();
        //     this.$alert(res.data.msg);
        //   }
        // });
        console.log('打印');
      },
      printHandler(val) {
        console.log(val);
        // this.loading.startLoading();
        const params = {
          id: this.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(PAYABLES_TRADE.PAYABLELIST_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            // this.loading.endLoading();
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          }
        });
      },

      // // 切换公司
      // changeCompanyHandler(val, partnerZhName1) {
      //   console.log(val, '切换公司', partnerZhName1);
      //   this.companyCode = val.val;
      //   this.query.settlementDepartmentNo = null;
      // },
      // 切换结算中心
      changeSettlementCenterHandler(val, partnerZhName1) {
        console.log(val, '结算中心', partnerZhName1);
        // this.query.settlementDepartmentNo = null;
      },

      // 切换供应商
      changeSupplyChainMethod(val) {
        this.query.supplierNo = val[0].partnerCode;
      },

      // 搜索
      async queryBtnClickHandler() {
        this.multipleSelection = [];
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        // this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        this.multipleSelection = [];
        if (this.userInfo.companyCode != 'OAC19') {
          this.query = {
            ...this.query,
            // settlementCompanyNo: this.userInfo.companyCode,
            // settlementDepartmentNo: this.userInfo?.departmentCode,
          };
          this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        }
        // setTimeout(() => {
        //   this.$refs.IPagination.handleSizeChange(this.$refs.IPagination.page.pageSize);
        // }, 50);
        setTimeout(() => {
          this.getTableData();
        }, 50);
      },
      // 获取表格数据
      async getTableData() {
        console.log('搜索');
        this.tableLoading = true;
        const postData = this.getQueryData();
        const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_QUERY, {
          ...postData,
          businessGroup: this.userInfo.businessGroup,
        });
        console.log(data, '搜索结果');
        this.tableLoading = false;
        if (data.code === 0) {
          this.multipleSelection = []; //初始化选中数据
          this.tableData = data.data.records;
          this.tableData.forEach((item) => {
            item.payableAccountPeriod = item.payableAccountPeriod
              ? item.payableAccountPeriod.slice(0, 7)
              : '';
          });
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.clearCheckboxReserve();
        }
      },

      // 新增按钮
      addNewSettleAccountsHandler() {
        if (this.userInfo.businessGroup == '物贸') {
          this.chooseBusinessHandler('贸易');
        } else if (this.userInfo.businessGroup == '城矿') {
          this.chooseBusinessHandler('城矿');
        } else {
          this.$refs.addDialogRef.openDialog();
        }
      },
      chooseBusinessHandler(val) {
        console.log(val, '新增val');

        if (val == '贸易') {
          this.publicName = this.publicPath = 'tradePayablesDetail';
        } else if (val == '多式联运') {
          // this.$message.error('该板块还在开发中');
          // return;
          this.publicName = this.publicPath = 'multimodalTransportPayablesDetail';
        } else if (val == '三方租赁') {
          this.publicName = this.publicPath = 'leaseContractDetail';
        } else if (val == '园区物业') {
          this.publicName = this.publicPath = 'parkPropertyPayablesCreate';
        } else if (val == '城矿') {
          this.publicName = this.publicPath = 'chengkuangPayablesCreate';
        }
        this.publicTitle = `${val}应付结算单`;
        let path = {
          path: `/receivablesAndPayables/${this.publicPath}`,
          name: `${this.publicName}`,
          meta: {
            keepAlive: true,
            title: `${this.publicTitle}`,
          },
          query: {
            status: 'create',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // // 表格中选择
      // handleSelectionChange(ev) {
      //   this.multipleSelection = ev.selection;
      // },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
      },
      // 双击行
      dblclickEvent({ row }) {
        console.log(row, row.settlementBusinessType);

        // if (!['01'].includes(row.settlementBusinessType)) {
        if (!['01', '02', '03', '04', '05'].includes(row.settlementBusinessType)) {
          this.$message.error('其他业务板块正在开发中！');
          return;
        } else {
          this.judgeBusinessType(row);
        }
        let path = {
          path: `/receivablesAndPayables/chengkuangPayablesCreate`,
          name: `chengkuangPayablesCreate`,
          meta: {
            keepAlive: true,
            title: `城矿应付结算`,
          },
          query: {
            status: 'detail',
            payNo: row.payableSettlementNo,
            id: row.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      storageCreatePersonName() {
        return this.userInfo.personName;
      },

      searchFormColumns() {
        return searchColumns(this);
      },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      payPaymentStatus() {
        return this.dictListMap?.pay_paymentStatus;
      },
    },
    mounted() {
      this.getButtonList();
      // this.queryBtnClickHandler();
      // console.log(this.dictListMap.pay_paymentStatus, '混入');
    },
    components: {
      Print,
      PrintDemo,
      PrintDialog,
      AddDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    background: #fff;
    border-radius: 8px;
    .foot-btn-group {
      margin-top: 30px;
    }
  }
  ::v-deep {
    .vxe-toolbar {
      margin-top: 15px;
    }
  }
</style>
